import { Component, Input, OnInit, Output, EventEmitter, NgZone } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
// import { ActivatedRoute, Router } from '@angular/router';
import { MapService } from './../../../../../../Services/map.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { RouteService } from 'src/app/Services/route.service';
import { StorageService } from 'src/app/Services/storage.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

declare const Swal;
declare var google: any;


@Component({
    selector: 'rostering-pickup-point-manage',
    templateUrl: './pickup-point-manage.html'
})
export class RosteringPickupPointManage implements OnInit {

    @Input() _activeMenu: string = '';
    @Output() switchTo = new EventEmitter();
    @Input() _routeID: any;
    @Input() selectedVeh: any;
    @Input() googleSearch: boolean = true;
    // @Input() selectedVehPickupInfo: any;

    /* Api Data */
    public routeData: any = {};
    public vehicleData: any = {};

    /* Pickup Points Data */
    pickupPointData: any = [];
    pickupPoints: any = [];

    /* create pickup point form variables */
    public formObject = {
        title: '',
        eta: '',
        radius: 1,
        location: '',
        lat: '',
        lng: '',
    };
    public pickupForm: any = { ...this.formObject };
    public createPickup: boolean = false;

    /* Edit pickup point form variables */
    public editPickupForm: any = { ...this.formObject };
    public editIndex = -1;
    public editPPLabelIndex = -1;

    /* common form variables */
    public errorFormObject: any = {};
    public formSubmitted: boolean = false;

    /* Map variables */
    primaryMap: any;
    mapSearchDebounceTimeOut = null;
    markerId = 'pickupPointSelection';
    markerRadiusId = 'pickup-point-radius';
    mapSearchDataLists = [];
    public initialMarkers: boolean = true;
    pickupFromMap: boolean = false;
    public map_marker_vehRegNo_style = 'hidden';
    public mapSearchChangeObserver: any;


    /* Directives variables*/
    public closePopup: boolean = true;              //Employee Selection
    public closeLocationConfig: boolean = true;     //Location Change
    public closeManageVehicle: boolean = true;      //Swap vehicle
    public closeGuestPopup: boolean = true;          //Guest Selection
    public closeFavLocPopup: boolean = true;         //Start and End Location
    public swapVehicle: boolean = false;

    /* Favourite Location Directive Variables */
    public startLocation: any = {};
    public endLocation: any = {};
    public stEndLocData: any = {};
    public selectedTripLocId: any;
    public selectedStLoc: any = {};
    public selectedEndLoc: any = {};
    public favLocModalTitle = '';
    public selectedLocType = '';
    public editStEndLocation: boolean = false;
    public selectedStEndLoc = {};
    public stEndMarkers: boolean = true;

    /* Change employee duration variables (Temporaty to Permanent)*/
    public closeEmpTypePopup: boolean = true;
    public tempEmpIndex: any;
    public selectedPpIndex: any;
    public selectedFormType = '';
    public selectedEmployee: any = {};

    /* Guest Directive variables  */
    public selectedGuestList = [];            //Whole pickup Point selected Guest List 
    public pickupPointGuestList = [];         //pickup form selected Guest List
    public initialGuestAdd: boolean = true;
    public guestEdit: boolean = false;
    public editGuestObj = {};
    public editGuestIndex = -1;
    public guestModalTitle = "Guest Selection";

    /* Employee Selection Directive variables */
    public getSelectedEmpList: any = {};

    /* Duration variables */
    public updateDuration: boolean = false;

    /* Common Methods */
    public objKeys = Object.keys;

    //for map
    public selectedMap: string = 'osrm';
    // public selectedMap:string='google';
    private googleMapObj: any;
    public routeLine: any;
    public gglPickupPointMarker: any = [];
    public pickupRadiusCircle: any;
    public markerPickupPoint: any;
    public pPointMarker: any = [];
    public generalSetting: boolean = false;

    constructor(
        public mapService: MapService,
        public api: ApiService,
        public comservice: CommonServices,
        private swal: SweetAlert,
        private routeservice: RouteService,
        private storage: StorageService,
        private route: Router,
        private _snackBar: MatSnackBar,
        private ngZone: NgZone,
    ) {
        let userInfo = this.storage.get('userInfo');
        if (userInfo?.general?.event == true) this.generalSetting = true;
    }

    ngOnInit() {
        let user = this.storage.get('userInfo');
        if (user && user.map) {
            this.selectedMap = user.map;
        }

        this.getRouteData();                            // Get selected Route Information
        this.getStEndLocationData();                    // Get selected Vehicle start and End Location 
        this.loadMap();                                 // Initiate Map 
        setTimeout(() => this.getPickupList(), 500);       // Get pickup Point list
        setTimeout(() => this.scrollToPageTop(), 1000);   // Scroll page to top for cross browser support
    }



    /******************************** Api Data retriving *****************************************/

    // Route Data 
    getRouteData() {
        this.api.transportMangerRouteList({ routeID: this._routeID, }).then((res: any) => {
            if (res.status == 'success') {
                this.routeData = res.data[0];
                this.routeData['startTimeStr'] = this.getTimeString(this.routeData['startTimeStr']);
                this.routeData['endTimeStr'] = this.getTimeString(this.routeData['endTimeStr']);
                if (this.routeData.routeType != 'openBooking') {
                    this.formObject['employees'] = [];
                    this.formObject['guest'] = [];
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }
    // PickupPoint Data
    getPickupList() {
        let obj = { routeID: this._routeID, vehRegNo: [this.selectedVeh.vehRegNo] };
        let apiMethod = 'listRoutePickupPoint';
        if (this.routeData && this.routeData.routeType && this.routeData.routeType == 'openBooking')
            apiMethod = 'transportManagerOpenBookingRouteListPP';

        this.api[apiMethod](obj).then((res: any) => {
            if (res.status == 'success' || res.status == 'Success') {
                // this.pickupPoints = [...res.data];
                // this.pickupPointData = [...res.data];

                // this.pickupPoints = this.pickupPoints.reverse();
                let results: any = res.data.map((pp: any) => {
                    let pPobj = { ...pp };
                    try {
                        if (pp.eta) {
                            let eta = String(pp.eta).toLowerCase();
                            let [hour, min]: any = eta.split(':');
                            if (eta.includes('pm')) {
                                let val = eta.split(':');
                                hour = +val[0] + 12;
                                let [mins, meriden] = val[1].split(' ');
                                min = +mins;
                            }
                            let etaHrs = new Date(new Date().setHours(hour, min)).getHours();
                            let etaMins = this.comservice.pad(new Date(new Date().setHours(hour, min)).getMinutes());
                            let finalEta = `${etaHrs}.${etaMins}`;
                            pPobj['etaDecimal'] = Number.parseFloat(finalEta);
                        }
                    }
                    catch (err) {
                        console.log(err)
                    }
                    return pPobj;
                })
                results = results.sort((a, b) => a.etaDecimal - b.etaDecimal);
                this.pickupPointData = [...results];
                this.pickupPoints = [...results];

                // this.pickupPointData = this.pickupPointData.reverse();

                this.getSelectedGuestList(res.data);
                this.pickupPoints.map((item) => {
                    item.eta = this.getTimeString(item.eta);
                    return item;
                });
                if (this.updateDuration) this.getEstDuration();

                if (this.pickupPoints.length > 0) {
                    if (this.selectedMap == 'google') {
                        this.pickupPointLocations();
                    } else {
                        if (this.primaryMap) {
                            this.pickupPointLocations();
                        }
                    }
                }
                else if (this.primaryMap) this.setStEndLocMarker([]);

            } else {
                this.pickupPoints = [];
                this.selectedGuestList = [];
                this.getSelectedEmpList = {};
                setTimeout(() => {
                    if (this.updateDuration) this.getEstDuration();
                    if (this.primaryMap) {
                        this.primaryMap.removeMarkerAll();
                        this.primaryMap.removeLineArrow(['route_rostering_pickupPoint_line']);
                        this.primaryMap.removeLine(['route_rostering_pickupPoint_line']);
                        this.setStEndLocMarker([]);
                    }
                }, 1000);
            }
        });
    }
    // Start & End Location Data
    getStEndLocationData() {
        let obj = { routeID: this._routeID, vehRegNo: [this.selectedVeh.vehRegNo] };
        this.api.transportManagerRouteStEndLocList(obj).then((res: any) => {
            if (res.status == 'success') {
                this.stEndLocData = { ...res.data[this.selectedVeh.vehRegNo] };
                if (Object.keys(this.stEndLocData).length > 0) {
                    if (this.stEndLocData.startLoc) {
                        this.selectedStLoc = { ...this.stEndLocData.startLoc };
                        this.startLocation = { ...this.stEndLocData.startLoc };
                    }
                    if (this.stEndLocData.endLoc) {
                        this.selectedEndLoc = { ...this.stEndLocData.endLoc };
                        this.endLocation = { ...this.stEndLocData.endLoc };
                    }
                    this.selectedTripLocId = this.stEndLocData.tripLocID;
                    if (this.primaryMap) {
                        if (this.pickupPoints.length > 0) this.pickupPointLocations();      // plot pickup Points marker
                        else this.setStEndLocMarker([]);                                    // plot start and end location marker only
                    }
                }
                if (this.updateDuration) this.getEstDuration();
            }
        }).catch((err) => {
            console.log(err);
        });
    }
    // Api retrived data supportive methods
    getTimeString(timeString) {                           // time '10:20'
        let splitTime = timeString.split(":");            // 10, 20

        let hour = this.comservice.pad(Number(splitTime[0]));
        let minute = this.comservice.pad(Number(splitTime[1]));

        let timeformat = `${hour}:${minute}`;
        return timeformat;
    }
    // check member Icon and member count
    checkAllMemIconOrCount(PPs, memType, resultType) {
        let pp = [];
        if (Array.isArray(PPs)) pp = PPs;
        else pp.push(PPs);

        let escortCount: any = 0;
        let maleCount: any = 0;
        let femaleCount: any = 0;
        for (let p = 0; p < pp.length; p++) {
            let data = pp[p];
            if (data.employees && data.employees.length > 0) {
                let employees = data.employees;
                if (memType == 'escort') escortCount += this.checkMemIconOrCount(employees, memType, 'count', 'department', 'escort');
                if (memType == 'male') maleCount += this.checkMemIconOrCount(employees, memType, 'count', 'department', 'escort');
                if (memType == 'female') femaleCount += this.checkMemIconOrCount(employees, memType, 'count', 'department', 'escort');
            }
            if (data.guest && data.guest.length > 0) {
                let guests = data.guest;
                if (memType == 'escort') escortCount += this.checkMemIconOrCount(guests, memType, 'count', 'userType', 'Escort');
                if (memType == 'male') maleCount += this.checkMemIconOrCount(guests, memType, 'count', 'userType', 'Escort');
                if (memType == 'female') femaleCount += this.checkMemIconOrCount(guests, memType, 'count', 'userType', 'Escort');
            }
        }
        if (resultType == 'icon') {
            if (this.routeData && this.routeData.routeType && this.routeData.routeType == 'openBooking') return false;

            if (memType == 'escort' && escortCount > 0) return true;
            else if (memType == 'male' && maleCount > 0) return true;
            else if (memType == 'female' && femaleCount > 0) return true;
            else return false;
        } else if (resultType == 'count') {
            if (this.routeData && this.routeData.routeType && this.routeData.routeType == 'openBooking') return 0;
            if (memType == 'escort') return escortCount;
            else if (memType == 'male') return maleCount;
            else if (memType == 'female') return femaleCount;
            else return 0;
        }
    }
    checkMemIconOrCount(mem, memType, resultType, escortKey, escortValue) {
        let members = [];
        if (Array.isArray(mem)) members = [...mem];
        else members.push(mem);

        let escortCount = 0;
        let maleCount = 0;
        let femaleCount = 0;
        for (let m = 0; m < members.length; m++) {
            let member = members[m];
            if (member.gender == "Male") {
                if (member[escortKey] && member[escortKey] == escortValue) escortCount++;
                else maleCount++;
            }
            if (member.gender == 'Female') {
                if (member[escortKey] && member[escortKey] == escortValue) escortCount++;
                else femaleCount++;
            }
        }
        if (resultType == 'icon') {
            if (memType == 'escort' && escortCount > 0) return true;
            else if (memType == 'male' && maleCount > 0) return true;
            else if (memType == 'female' && femaleCount > 0) return true;
            else return false;
        } else if (resultType == 'count') {
            if (memType == 'escort') return escortCount;
            else if (memType == 'male') return maleCount;
            else if (memType == 'female') return femaleCount;
            else return 0;
        }
    }

    /*********************************************************************************************/

    /************** Process pickup point location for Plot line and marker in map ***************/
    pickupPointLocations() {
        let sortedPickupPoints = this.pickupPoints.sort(
            (p1, p2) => (p1.etaDecimal > p2.etaDecimal) ? 1 : (p1.etaDecimal < p2.etaDecimal) ? -1 : 0);
        let pickupLocations = sortedPickupPoints.map((pp) => {
            let item = pp;
            return [item.lat, item.lng, { title: item.title }];
        });
        // pickupLocations=pickupLocations.reverse();
        //this.loadMap();
        //this.primaryMap.removeLine('Aline');
        setTimeout(() => {
            if (this.objKeys(this.startLocation).length > 0)
                pickupLocations.unshift([this.startLocation.lat, this.startLocation.lng])
            if (this.objKeys(this.endLocation).length > 0)
                pickupLocations.push([this.endLocation.lat, this.endLocation.lng])

            if (this.selectedMap == 'google') {
                this.plotLine(pickupLocations);
            } else {
                this.drawLine(pickupLocations);
            }
        }, 500);

    }
    /********************************************************************************************/

    /************** Go back to Route Form Module Or Dashboard routeExploration ******************/
    switchToAction() {
        let chekRouteExplore = this.storage.get('routeExploration');

        if (chekRouteExplore != undefined && chekRouteExplore != null && chekRouteExplore != '') {
            this.route.navigate(['organization/transport-manager/dashboard']);
        } else {
            if (this.selectedMap != 'google') {
                this.primaryMap.removeMarkerAll();
                this.primaryMap.removeLineArrow(['route_rostering_pickupPoint_line']);
                this.primaryMap.removeLine(['route_rostering_pickupPoint_line']);
            }
            this.switchTo.emit('Route');
        }
    }
    /********************************************************************************************/

    /************************************* Scroll to page top ***********************************/
    scrollToPageTop() {
        // This prevents the page from scrolling down to where it was previously.
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        // This is needed if the user scrolls down during page load and you want to make sure the page is scrolled to the top once it's fully loaded. This has Cross-browser support.
        window.scrollTo(0, 0);
    }
    /*******************************************************************************************/

    /************************************* Initiate Map ****************************************/
    loadMap() {
        if (this.selectedMap == 'google') {
            setTimeout(() => {
                const mapOptions = {
                    scrollwheel: true,
                    zoom: 5,
                    maxZoom: 17,
                    center: new google.maps.LatLng(20.5937, 78.9629),
                    fullscreenControl: false,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.LEFT_TOP,
                    },
                    mapTypeControl: true,
                    mapTypeControlOptions: {
                        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                        position: google.maps.ControlPosition.TOP_CENTER,
                    },
                    streetViewControl: false,
                };
                this.googleMapObj = new google.maps.Map(document.getElementById('primaryMap'), mapOptions);
                google.maps.event.addListener(this.googleMapObj, 'click', (e) => {
                    if (this.pickupFromMap) {
                        let obj = {
                            "params": {
                                "latlng": `${+e.latLng.lat().toFixed(5)},${+e.latLng.lng().toFixed(5)}`
                            }
                        }
                        let response;
                        this.api.transportManagerGoogleMapGeocoder(obj).then((res: any) => {
                            if (res.status == 'success') {
                                response = JSON.parse(res.data);
                                this.pickupPointLocationChanged(+e.latLng.lat(), +e.latLng.lng(), response['results'][0]['formatted_address']);
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                        this.removeCircleAndMarker();
                        this.gglPickupPointMarkerLoc(+e.latLng.lat(), +e.latLng.lng(), '');
                        let loc = {
                            lat: +e.latLng.lat(),
                            lng: +e.latLng.lng()
                        }
                        this.drawCircleGgl(loc);
                        this.googleMapObj.setZoom(15);
                    }
                });
            }, 1000)
        } else {
            this.mapService.map("primaryMap").then((map) => {
                this.primaryMap = map;
                this.primaryMap.onMapClick(($event) => this.mapClickEventListen($event));
                this.primaryMap.onMapZoom((z) => {
                    /* show vehicle Reg No when zoom level is above 13 */

                    if (z >= 13) {
                        if (this.map_marker_vehRegNo_style == 'hidden') {
                            const veh_Reg_nums = document.querySelectorAll('.map_marker_vehRegNo');
                            for (let i = 0; i < veh_Reg_nums.length; i++) {
                                const elem: any = veh_Reg_nums[i];
                                elem.style.visibility = 'visible';
                            }
                            this.map_marker_vehRegNo_style = 'visible';
                        }
                    }
                    else {
                        if (this.map_marker_vehRegNo_style == 'visible') {
                            const veh_Reg_nums = document.querySelectorAll('.map_marker_vehRegNo');
                            for (let i = 0; i < veh_Reg_nums.length; i++) {
                                const elem: any = veh_Reg_nums[i];
                                elem.style.visibility = 'hidden';
                            }
                            this.map_marker_vehRegNo_style = 'hidden';
                        }
                    }
                    const veh_Reg_nums = document.querySelectorAll('.map_marker_vehRegNo');
                    for (let i = 0; i < veh_Reg_nums.length; i++) {
                        const elem: any = veh_Reg_nums[i];
                        const mapID = `route_rostering_pickupPoint_ppMiddleMarker_${this.editPPLabelIndex}`;
                        if (elem.id == mapID) elem.style.visibility = 'hidden';
                    }
                });
            }).catch((error) => {

            });
        }
        setTimeout(() => {
            if (this.pickupPoints.length > 0)
                this.pickupPointLocations();
        }, 1000)
    }
    /******************************************************************************************/

    /************************************* Map methods ****************************************/
    // map click event method
    mapClickEventListen($event) {
        if (this.pickupFromMap === false || (this.editIndex === -1 && this.createPickup === false)) return;

        this.pickupPointMarker($event['lngLat']['lat'], +$event['lngLat']['lng']);

        this.pickupPointLocationChanged($event['lngLat']['lat'], +$event['lngLat']['lng'])

        this.latlngDrawRadius($event['lngLat']['lat'], $event['lngLat']['lng']);
        if (this.primaryMap && this.markerId) {
            this.primaryMap.onDrag([this.markerId], (e) => {
                this.pickupPointLocationChanged(e.target._lngLat['lat'], e.target._lngLat['lng'])
                this.latlngDrawRadius(+e.target._lngLat['lat'], e.target._lngLat['lng']);
            });
        }

    }
    drawCircleGgl(loc) {
        this.pickupRadiusCircle = new google.maps.Circle({
            strokeColor: "rgb(98,100,167)",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "rgb(154,155,194)",
            fillOpacity: 0.35,
            map: this.googleMapObj,
            center: loc,
            radius: Math.sqrt(10) * 100,
        });
    }

    // plot marker and focus the location
    pickupPointMarker(lat, lng) {
        lat = +lat.toFixed(5); lng = +lng.toFixed(5);
        this.primaryMap.marker(
            {
                id: this.markerId,
                content: '<div class="mumb_marker_pin" style="background: #686ab9;"></div>',
                lat: lat,
                lng: lng,
                draggable: true   // <<<<< Important
            }
        );
        let focusObj = {
            lat: lat,
            lng: lng,
            zoom: 13
        };
        if (this.editPPLabelIndex != -1) focusObj.zoom = 14;
        this.primaryMap.focus(focusObj);
    }
    gglPickupPointMarkerLoc(lat, lng, name) {
        if (this.gglPickupPointMarker.length > 0) {
            for (let i = 0; i < this.gglPickupPointMarker.length; i++) {
                this.gglPickupPointMarker[i].setMap(null);
            }
        }
        let loc = {
            lat: +lat,
            lng: +lng,
        }
        var image = {
            origin: new google.maps.Point(0, 0),
            url: "assets/images/map/googleMap/pickuppoint-purple.png",
            scaledSize: new google.maps.Size(24, 36),
        };
        this.gglPickupPointMarker.push(new google.maps.Marker({
            position: loc,
            map: this.googleMapObj,
            icon: image,
            draggable: true
        }));
        for (let i = 0; i < this.gglPickupPointMarker.length; i++) {
            this.gglPickupPointMarker[i].addListener('click', (e) => {
                this.googleMapObj.setZoom(15);
                this.googleMapObj.panTo(this.gglPickupPointMarker[i].position);
            })
            this.gglPickupPointMarker[i].addListener('dragend', (e) => {
                if (this.pickupRadiusCircle) {
                    this.pickupRadiusCircle.setMap(null);
                }
                let loc = {
                    lat: +e.latLng.lat(),
                    lng: +e.latLng.lng()
                }
                this.drawCircleGgl(loc);
                this.googleMapObj.setZoom(15);
                this.googleMapObj.panTo(loc);
                this.dragToFindAddress(e)
            });
        }
        this.googleMapObj.setZoom(10);
        this.googleMapObj.panTo(loc);
    }
    dragToFindAddress(e) {
        let editForm = this.editIndex != -1 && !this.createPickup;
        let createForm = this.editIndex == -1 && this.createPickup;
        let obj = {
            "params": {
                "latlng": `${+e.latLng.lat().toFixed(5)},${+e.latLng.lng().toFixed(5)}`
            }
        }
        this.api.transportManagerGoogleMapGeocoder(obj).then((res: any) => {
            if (res.status == 'success') {
                let response = JSON.parse(res.data);
                if (editForm) {
                    this.pickupPoints[this.editIndex]['lat'] = +e.latLng.lat();
                    this.pickupPoints[this.editIndex]['lng'] = +e.latLng.lng();
                    this.pickupPoints[this.editIndex]['location'] = response['results'][0]['formatted_address'];

                    this.editPickupForm['lat'] = +e.latLng.lat();
                    this.editPickupForm['lng'] = +e.latLng.lng();
                    this.editPickupForm['location'] = response['results'][0]['formatted_address'];
                    this.checkValidation('edit');
                } else if (createForm) {
                    this.pickupForm['lat'] = +e.latLng.lat();
                    this.pickupForm['lng'] = +e.latLng.lng();
                    this.pickupForm['location'] = response['results'][0]['formatted_address'];
                    this.checkValidation('create');
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }
    // Draw Radius for selected marker
    latlngDrawRadius(lat, lng) {
        let editForm = this.editIndex != -1 && !this.createPickup;
        let createForm = this.editIndex == -1 && this.createPickup;
        let km = 1;
        if (editForm) km = this.editPickupForm['radius'];
        if (createForm) km = this.pickupForm['radius'];
        if (this.selectedMap == 'google') {
            let loc = {
                lat: +lat,
                lng: +lng,
            }
            this.drawCircleGgl(loc);
        } else {
            this.primaryMap.drawCircle({
                name: this.markerRadiusId, // unique like id
                lat: +lat.toFixed(5), lng: +lng.toFixed(5),
                km: +(km).toFixed(2),
                color: "rgba(255,0,0,0.2)"
            });
        }
    }



    // Map search results
    mapSearchFind(location) {
        location = location.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

        if (!this.mapSearchChangeObserver) {
            new Observable(observer => {
                this.mapSearchChangeObserver = observer;
            }).pipe(debounceTime(1000)) // wait 500ms after the last event before emitting last event
                .pipe(distinctUntilChanged()) // only emit if value is different from previous value
                .subscribe((term: any) => {
                    // your code here
                    if (term == '') {
                        this.mapSearchDataLists = [];
                    }
                    else {

                        if (this.googleSearch) {
                            const options = {
                                fields: ["formatted_address", "geometry", "name"],
                                strictBounds: false,
                                types: ["establishment"],
                            };


                            const searchInput: any = document.getElementById('mapSearchBox');// as HTMLInputElement;

                            const autocomplete = new google.maps.places.Autocomplete(searchInput, options);
                            autocomplete.addListener('place_changed', () => {
                                this.ngZone.run(() => {
                                    const getResults = autocomplete.getPlace();
                                    /*
                                    Example Data 
                                    getRestults = {
                                        "formatted_address": "7, th street, Subramaniam Colony, Ram Nagar South, Madipakkam, Chennai, Tamil Nadu 600096, India",
                                        "geometry": {
                                            "location": {
                                                "lat": 12.9678217,
                                                "lng": 80.2185006
                                            },
                                            "viewport": {
                                                "south": 12.9665866697085,
                                                "west": 80.21685966970848,
                                                "north": 12.9692846302915,
                                                "east": 80.21955763029149
                                            }
                                        },
                                        "name": "Velachery Railway Station",
                                        "html_attributions": []
                                    } */
                                    try {
                                        let name = getResults.formatted_address ? getResults.formatted_address : '';
                                        let lat = getResults.geometry && getResults.geometry.location && getResults.geometry.location.lat() ? getResults.geometry.location.lat() : '';
                                        let lng = getResults.geometry && getResults.geometry.location && getResults.geometry.location.lng() ? getResults.geometry.location.lng() : '';
                                        if (lat != '' && lng != '') {
                                            if (this.selectedMap == 'google') {
                                                this.removeCircleAndMarker();
                                                this.gglPickupPointMarkerLoc(+lat, +lng, name);
                                                this.googleMapObj.setZoom(15);
                                            } else {
                                                this.pickupPointMarker(+lat, +lng);
                                            }
                                            this.latlngDrawRadius(+lat, +lng);
                                            this.pickupPointLocationChanged(+lat, +lng, name);
                                        }
                                    } catch (err) {
                                        console.log('location bind error', err);
                                    }

                                });
                            });

                        }
                        else {
                            this.primaryMap.geocoder(
                                `${term}`, (res) => {
                                    try {
                                        const locations = res.features.map(function (i) { return { center: i.center, name: i.place_name } });
                                        this.primaryMap.focus({
                                            lat: locations[0]['center'][1],
                                            lng: locations[0]['center'][0],
                                            zoom: 15
                                        });
                                        this.mapSearchDataLists = [];
                                        this.mapSearchDataLists = locations;
                                        // console.log(locations)
                                    } catch (er) { console.log(er) };
                                });
                        }
                    }
                });
        }

        this.mapSearchChangeObserver.next(location);
    }

    //Remove Marker and radius for selected form marker
    removeCircleAndMarker() {
        if (this.selectedMap == 'google') {
            if (this.gglPickupPointMarker.length > 0) {
                for (let i = 0; i < this.gglPickupPointMarker.length; i++) {
                    this.gglPickupPointMarker[i].setMap(null);
                }
            }
            if (this.pickupRadiusCircle) {
                this.pickupRadiusCircle.setMap(null);
            }
        } else {
            this.primaryMap.removeMarker(this.markerId);
            this.primaryMap.removeCircle(this.markerRadiusId);
        }
    }

    // Patch selected location into the form 
    pickupPointLocationChanged(lat, lng, locationName?) {
        let editForm = this.editIndex != -1 && !this.createPickup;
        let createForm = this.editIndex == -1 && this.createPickup;
        if (editForm) {
            this.pickupPoints[this.editIndex]['lat'] = +lat.toFixed(5);
            this.pickupPoints[this.editIndex]['lng'] = +lng.toFixed(5);
            this.editPickupForm['lat'] = +lat.toFixed(5);
            this.editPickupForm['lng'] = +lng.toFixed(5);
        } else if (createForm) {
            this.pickupForm['lat'] = +lat.toFixed(5);
            this.pickupForm['lng'] = +lng.toFixed(5);
        }

        if (locationName && locationName != '') {
            if (editForm) {
                this.pickupPoints[this.editIndex]['location'] = locationName;
                this.editPickupForm['location'] = locationName;
                this.checkValidation('edit');
            } else if (createForm) {
                this.pickupForm['location'] = locationName;
                this.checkValidation('create');
            }
        } else {
            let obj = {
                "params": {
                    "latlng": `${+lat.toFixed(5)},${+lng.toFixed(5)}`
                }
            }
            let response;
            this.api.transportManagerGoogleMapGeocoder(obj).then((res: any) => {
                if (res.status == 'success') {
                    response = JSON.parse(res.data);
                }
            }).catch((err) => {
                console.log(err);
            });
            if (editForm) {
                this.pickupPoints[this.editIndex]['location'] = response['results'][0]['formatted_address'];
                this.editPickupForm['location'] = response['results'][0]['formatted_address'];
                this.checkValidation('edit');
            } else if (createForm) {
                this.pickupForm['location'] = response['results'][0]['formatted_address'];
                this.checkValidation('create');
            }
            // if(this.selectedMap=='google'){
            // }else{
            //     this.primaryMap.geocoder(
            //         `${lng},${lat}`, (res) => {
            //             try {
            //                 const locations = res.features.map(function (i) { return { center: i.center, name: i.place_name } });
            //                 if (editForm) {
            //                     this.pickupPoints[this.editIndex]['location'] = locations[0]['name'];
            //                     this.editPickupForm['location'] = locations[0]['name'];
            //                     this.checkValidation('edit');
            //                 } else if (createForm) {
            //                     this.pickupForm['location'] = locations[0]['name'];
            //                     this.checkValidation('create');
            //                 }

            //             } catch (er) { console.log(er) };
            //     });
            // }
        }
    }

    //Draw line for pickup point and start and end locaiton markers
    async plotLine(locs) {
        if (this.gglPickupPointMarker.length > 0) {
            for (let i = 0; i < this.gglPickupPointMarker.length; i++) {
                this.gglPickupPointMarker[i].setMap(null);
            }
        }
        if (this.pPointMarker.length > 0) {
            for (let i = 0; i < this.pPointMarker.length; i++) {
                this.pPointMarker[i].setMap(null);
            }
        }
        setTimeout(() => {
            if (this.routeLine) {
                this.routeLine.setMap(null);
            }
        }, 100)
        let wayPointsLocations: any;
        wayPointsLocations = await this.routeservice.findWayPoints(locs);
        let position = {};
        let location = [];
        for (let i = 0; i < wayPointsLocations.length; i++) {
            if (Object.keys(wayPointsLocations[i]).length == 3) {
                position = {
                    lat: +wayPointsLocations[i][0],
                    lng: +wayPointsLocations[i][1],
                    pickupPoint: wayPointsLocations[i][2]['title']
                }
            } else {
                position = {
                    lat: +wayPointsLocations[i][0],
                    lng: +wayPointsLocations[i][1]
                }
            }
            if (i == 0) {
                position['loc'] = 'start';
            } else if (i == wayPointsLocations.length - 1) {
                position['loc'] = 'end';
            }
            location.push(position);
        }
        var image = {
            origin: new google.maps.Point(0, 0),
        };
        for (let i = 0; i < location.length; i++) {
            if (location[i].loc == 'start') {
                image['url'] = "assets/images/map/googleMap/start.png";
                image['scaledSize'] = new google.maps.Size(30, 35);
            } else if (location[i].loc == 'end') {
                image['url'] = "assets/images/map/googleMap/finish.png";
                image['scaledSize'] = new google.maps.Size(30, 35);
            } else if (location[i].pickupPoint) {
                image['url'] = "assets/images/map/googleMap/map_navyblue.png";
                image['scaledSize'] = new google.maps.Size(10, 10);
            }
            if (i == 0 || i == location.length - 1) {
                let marker = new google.maps.Marker({
                    position: location[i],
                    map: this.googleMapObj,
                    icon: image
                })
                marker.addListener('click', (e) => {
                    this.googleMapObj.setZoom(15);
                    this.googleMapObj.panTo(location[i]);
                })
            }
            if (location[i].pickupPoint) {
                this.pPointMarker.push(new google.maps.Marker({
                    position: location[i],
                    map: this.googleMapObj,
                    icon: image
                }));
                let infoWindowContent;
                let infowindow;
                let filVal;
                for (let j = 0; j < this.pPointMarker.length; j++) {
                    this.pPointMarker[j].addListener('click', (e) => {
                        filVal = this.pickupPointData.filter(obj => e.latLng.lat() == obj.lat && e.latLng.lng() == obj.lng);
                        if (infowindow) infowindow.close();
                        if (filVal.length > 0) {
                            infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + filVal[0].title + '</span><div style="margin-top:2px">' + 'Vehicle :' + '<span>' + ' ' + filVal[0].vehRegNo + '</span></div><div style="margin-top:2px">' + 'ETA :' + '<span>' + ' ' + filVal[0].eta + '</span></div><div style="margin-top:2px">' + 'Updated :' + ' ' + '<span>' + this.toDateFormat(filVal[0].updatedAt) + '</span>' + '</div>' + '</div>';
                            infowindow = new google.maps.InfoWindow({
                                content: infoWindowContent
                            });
                        }
                        this.googleMapObj.setZoom(15);
                        this.googleMapObj.panTo(this.pPointMarker[j].position);
                    })
                    google.maps.event.addListener(this.pPointMarker[j], 'click', function () {
                        infowindow.open(this.googleMapObj, this);
                    });
                }
            }
        }
        this.routeLine = new google.maps.Polyline({
            path: location,
            geodesic: true,
            strokeColor: "#444",
            strokeOpacity: 1.0,
            strokeWeight: 2,
        })
        this.routeLine.setMap(this.googleMapObj);
        var bounds = new google.maps.LatLngBounds();
        for (let i = 0; i < location.length; i++) {
            bounds.extend(location[i]);
        }
        bounds.getCenter();
        this.googleMapObj.fitBounds(bounds);
    }
    toDateFormat(value) {
        if (!value) return '';
        let date: any = new Date(value);
        var Str = ("00" + (date.getDate() + 1)).slice(-2)
            + "/" + ("00" + date.getMonth()).slice(-2)
            + "/" + date.getFullYear() + " "
            + ("00" + date.getHours()).slice(-2) + ":"
            + ("00" + date.getMinutes()).slice(-2)
            + ":" + ("00" + date.getSeconds()).slice(-2);
        return Str;
    }
    async drawLine(locations = []) {
        let wayPointsLocations = await this.routeservice.findWayPoints(locations);
        setTimeout(() => {
            this.primaryMap.addLine({
                id: 'route_rostering_pickupPoint_line',
                //locations: locations,
                locations: wayPointsLocations,
                color: 'red',
                width: 3,
                // dash : 2,
                animation: false,
                //lineBearing: 1 * 1000,
                //startMarker: '<div class="mumb_marker_pin" style="background: green;"></div><div class="mumb_marker_pulse" style="background: green;"></div>',
                //  bearingMarker : '<div class="mumb_marker_pulse" style="background: red;"></div>', //'<img src="map-assets/images/ripple-circle.gif">' 
                bearingFocus: true,
                //plotMarker: '<div class="mumb_marker_pulse" style="background: black; width: 10px;"></div>',
                //endMarker: '<div class="mumb_marker_pin" style="background: red;"></div><div class="mumb_marker_pulse" style="background: red;"></div>',
                drawArrow: {
                    colorClass: 'secondary'
                }
            });
            this.addPickupPointMarker();
        }, 500)
    }

    // process pickup points lat,lng & start and end locaiton for markers
    addPickupPointMarker() {
        let locations = this.pickupPoints.map((pp) => {
            let item = pp;
            //   let item = pp.pickupInfo;
            return [item.lat, item.lng, { title: item.title }];
        });
        this.setStEndLocMarker(locations);
    }

    // process Markers for given locations lat,lng,title
    setStEndLocMarker(locations) {
        let markers = [];
        if (this.objKeys(this.startLocation).length > 0) {
            let sMarker = {
                id: 'route_rostering_pickupPoint_ppStartMarker',
                content: '<div class="mumb_marker_pin mumb_marker_car_white" style="background: green;"></div><div class="mumb_marker_pulse" style="background: green;"></div>',
                lat: this.startLocation.lat,
                lng: this.startLocation.lng,
            };
            markers.push(sMarker);
        }
        if (this.objKeys(this.endLocation).length > 0) {
            let eMarker = {
                id: 'route_rostering_pickupPoint_ppEndMarker',
                content: '<div class="mumb_marker_pin" style="background: red;"></div><div class="mumb_marker_pulse" style="background: red;"></div>',
                lat: this.endLocation.lat,
                lng: this.endLocation.lng,
            };
            markers.push(eMarker);
        }
        if (locations.length > 0) {
            locations.filter((loc, i) => {
                let plotMarker = {
                    id: `route_rostering_pickupPoint_ppMiddleMarker_${i}`,
                    content: `<div class="mumb_marker_pulse" style="background: #6264a7; width: 10px;"></div>
                        <span class="map_marker_vehRegNo rosteringPPtitle" id="route_rostering_pickupPoint_ppMiddleMarker_${i}" *ngIf="${this.markerTitleTitlecase(loc[2]['title']) != ''}">${(i + 1) + '. ' + this.markerTitleTitlecase(loc[2]['title'])}</span>`,
                    lat: loc[0],
                    lng: loc[1],
                }
                markers.push(plotMarker);
            })
        }
        this.primaryMap.removeMarkerAll();
        this.primaryMap.addMarkers(markers);
        setTimeout(() => {
            if (this.initialMarkers) {
                if (this.objKeys(this.startLocation).length > 0) {
                    let focusObj = { lat: this.startLocation.lat, lng: this.startLocation.lng, zoom: 13, }
                    if (this.objKeys(this.endLocation).length > 0) {
                        focusObj = { lat: this.endLocation.lat, lng: this.endLocation.lng, zoom: 13, }
                    }
                    this.primaryMap.focus(focusObj);
                    this.initialMarkers = false;
                }
            }
        }, 500);
    }

    markerTitleTitlecase(title) {
        if (title != '') {
            let result = title.toLowerCase().split(' ').map((w) => { return (w.charAt(0).toUpperCase() + w.slice(1)) });
            return result.join(' ');
        }
        else return ''
    }
    /****************************************************************************************/

    /********************************** Seat Available Count ********************************/
    getAvailableCount() {
        let count = 0;
        if (this.pickupPoints.length > 0) {
            this.pickupPoints.filter((e) => {
                if (e.employees) count += e.employees.length;
                if (e.guest) count += e.guest.length;
            });
        }
        return count;
    }
    getAvailableEmpCount() {
        let count = 0;
        if (this.editIndex != -1) {
            if (this.pickupPoints.length > 0) {
                for (let p = 0; p < this.pickupPoints.length; p++) {
                    if (p != this.editIndex) {
                        if (this.pickupPoints[p].guest) count += this.pickupPoints[p].guest.length;
                    }
                }
            }
            if (this.editPickupForm.guest) count += this.editPickupForm.guest.length;
        }
        if (this.createPickup) {
            if (this.pickupPoints.length > 0) {
                for (let p = 0; p < this.pickupPoints.length; p++) {
                    if (this.pickupPoints[p].guest) count += this.pickupPoints[p].guest.length;
                }
            }
            if (this.pickupForm.guest) count += this.pickupForm.guest.length;
        }
        let result = (this.selectedVeh.capacity - count) < 0 ? 0 : (this.selectedVeh.capacity - count);
        return result;
    }
    getAvailableGuestCount() {
        let count = 0;
        if (this.pickupPoints.length > 0) {
            for (let p = 0; p < this.pickupPoints.length; p++) {
                if (p != this.editIndex) {
                    if (this.pickupPoints[p].employees) count += this.pickupPoints[p].employees.length;
                    if (this.pickupPoints[p].guest) count += this.pickupPoints[p].guest.length;
                }
            }
        }
        if (this.editIndex != -1) {
            if (this.editPickupForm.employees) count += this.editPickupForm.employees.length;
            if (this.editPickupForm.guest) count += this.editPickupForm.guest.length;
        }
        if (this.createPickup) {
            if (this.pickupForm.employees) count += this.pickupForm.employees.length;
            if (this.pickupForm.guest) count += this.pickupForm.guest.length;
        }
        let result = (this.selectedVeh.capacity - count) < 0 ? 0 : (this.selectedVeh.capacity - count);
        return result;
    }
    /***************************************************************************************/


    /************************ Start Location and End Locaiton methods **********************/

    // Open Location selection modal to get Start and end location
    getFavLocation(field) {
        this.editStEndLocation = false;
        this.selectedStEndLoc = {};
        this.selectedLocType = field;
        if (field == 'start Location') this.favLocModalTitle = "Start Location";
        else if (field == 'end Location') this.favLocModalTitle = "End Location";
        this.closeFavLocPopup = false;
    }

    // Get selected location object then process object for API call
    selectedFavLocation(event) {
        let obj = {
            routeID: this._routeID,
            vehRegNo: this.selectedVeh.vehRegNo,
        }
        if (this.selectedLocType == 'start Location') {
            this.startLocation = { ...event };
            obj['startLoc'] = { ...event };
        }
        else if (this.selectedLocType == 'end Location') {
            this.endLocation = { ...event };
            obj['endLoc'] = { ...event };
        }
        if (this.selectedTripLocId) {
            this.updateStEndLocation(obj);
        }
        else {
            this.createStEndLocation(obj);
        }
        this.closeFavLocPopup = true;
        this.loadMap();
    }

    // Create new Start or End location for vehicle
    createStEndLocation(obj) {
        this.api.transportManagerRouteStEndLocCreate(obj).then((res: any) => {
            if (res.status == 'success') {
                this.swal.swalFunction(res.status.toLowerCase(), res.status, res.message, 2000);
                this.updateDuration = true;
                this.getStEndLocationData();
            } else {
                this.swal.swalFunction('error', res.status, res.message, 2000);
            }
        })
    }

    // Edit start and end location 
    editFavLocation(field) {
        this.selectedLocType = field;
        this.selectedStEndLoc = {};
        if (field == 'start Location') {
            this.favLocModalTitle = "Start Location";
            this.selectedStEndLoc = { ...this.startLocation };
        }
        else if (field == 'end Location') {
            this.favLocModalTitle = "End Location";
            this.selectedStEndLoc = { ...this.endLocation };
        }
        this.editStEndLocation = true;
        this.closeFavLocPopup = false;
    }

    // Update start or end location for Vehicle
    updateStEndLocation(obj) {
        obj['tripLocID'] = this.selectedTripLocId;
        this.api.transportManagerRouteStEndLocUpdate(obj).then((res: any) => {
            if (res.status == 'success') {
                this.swal.swalFunction(res.status.toLowerCase(), res.status, res.message, 2000);
                this.updateDuration = true;
                this.getStEndLocationData();
            } else {
                this.swal.swalFunction('error', res.status, res.message, 2000);
            }
        })
    }

    //Start and End Location Alert for create new pickup point without start and end location
    addStEndLocAlert() {
        Swal.fire({
            title: 'Add Locations',
            text: 'Add Start and End Location!',
            icon: 'info',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok'
        });
    }
    // get estimated duration when pickuppoint location changes or start and end location changes
    async getEstDuration() {
        if (Object.keys(this.stEndLocData).length > 0) {
            // console.log('start and end location',this.stEndLocData);
            if (this.stEndLocData['startLoc'] && this.stEndLocData['endLoc']) {
                let distance = 0;
                let duration = 0;
                if (this.pickupPointData.length > 0) {
                    for (let p = 0; p < this.pickupPointData.length; p++) {
                        let previousLoc = {};
                        let currentLoc = {};
                        if (p == 0) {
                            previousLoc = { lat: this.stEndLocData['startLoc']['lat'], lng: this.stEndLocData['startLoc']['lng'], }
                            currentLoc = { lat: this.pickupPointData[p]['lat'], lng: this.pickupPointData[p]['lng'], };
                            let result = await this.routeservice.findETADist(previousLoc, currentLoc);
                            distance += Number(parseFloat(result['distance']).toFixed(2));
                            duration += Number(parseFloat(result['eta']).toFixed(2));
                            // console.log('start',distance,duration,result);
                        }
                        if (p == this.pickupPointData.length - 1) {
                            previousLoc = { lat: this.pickupPointData[p]['lat'], lng: this.pickupPointData[p]['lng'], };
                            currentLoc = { lat: this.stEndLocData['endLoc']['lat'], lng: this.stEndLocData['endLoc']['lng'], };
                            let result = await this.routeservice.findETADist(previousLoc, currentLoc);
                            distance += Number(parseFloat(result['distance']).toFixed(2));
                            duration += Number(parseFloat(result['eta']).toFixed(2));
                            // console.log('end',distance,duration,result);

                        }
                        if (p != 0 && p != this.pickupPointData.length - 1) {
                            previousLoc = { lat: this.pickupPointData[p - 1].lat, lng: this.pickupPointData[p - 1].lng };
                            currentLoc = { lat: this.pickupPointData[p].lat, lng: this.pickupPointData[p].lng };
                            let result = await this.routeservice.findETADist(previousLoc, currentLoc);
                            distance += Number(parseFloat(result['distance']).toFixed(2));
                            duration += Number(parseFloat(result['eta']).toFixed(2));
                            // console.log(distance,duration,result);
                        }
                    }
                } else {
                    let startLoc = { lat: this.stEndLocData.startLoc.lat, lng: this.stEndLocData.startLoc.lng };
                    let endLoc = { lat: this.stEndLocData.endLoc.lat, lng: this.stEndLocData.endLoc.lng };
                    let result = await this.routeservice.findETADist(startLoc, endLoc);
                    distance += Number(parseFloat(result['distance']).toFixed(2));
                    duration += Number(parseFloat(result['eta']).toFixed(2));
                }
                setTimeout(() => {
                    let obj = {
                        distance: String(distance),
                        duration: this.convertMintoHours(duration),
                        routeID: this._routeID,
                        vehRegNo: this.selectedVeh.vehRegNo,
                        tripLocID: this.selectedTripLocId
                    };
                    // console.log('api update ##########',obj);                    
                    this.api.transportManagerRouteStEndLocUpdate(obj);   // update duration & distance in Start & end location API
                }, 500);
            }
        }
    }
    convertMintoHours(mins) {
        let H: string | number, h = Math.floor(mins / 60);
        let M: string | number, m = mins % 60;
        H = h < 10 ? '0' + h : h;
        M = m < 10 ? '0' + m : m;
        return `${H}.${M}`;
    }
    /**************************************************************************************/

    /******************************* Swap vehicle methods ********************************/
    changeVehicle(obj) {
        this.selectedVeh = { ...obj };
        setTimeout(() => { this.getPickupList() }, 200);
    }

    /*************************************************************************************/

    /*************************** Create Pickup Point methods *****************************/

    // process pickup point form 
    addPickupPoint() {
        if (this.objKeys(this.startLocation).length > 0 && this.objKeys(this.endLocation).length > 0) {
            this.pickupForm = { ...this.formObject };
            if (this.routeData && this.routeData.routeType && this.routeData.routeType != 'openBooking') {
                this.pickupForm['employees'] = [];
                this.pickupForm['guest'] = [];
            }
            this.createPickup = true;
            this.editIndex = -1;
            this.formSubmitted = false;
        } else {
            this.addStEndLocAlert();
        }
    }

    // cancel create pickup point form
    cancelForm() {
        this.createPickup = false;
        this.errorFormObject = {};
        this.pickupFromMap = false;
        this.formSubmitted = false;
        this.pickupForm = { ...this.formObject };
        this.pickupPointGuestList = [];
        this.removeCircleAndMarker();
    }
    /************************************************************************************/

    /************************** Edit Pickup Point methods *******************************/

    // patch pickup point information into editpickup point form
    editPickupPoint(i) {
        this.createPickup = false;
        this.formSubmitted = false;
        this.editIndex = i;
        this.pickupPointGuestList = [];
        this.editPickupForm = {
            title: this.pickupPoints[i].title,
            eta: this.pickupPoints[i].eta,
            radius: this.pickupPoints[i].radius,
            location: this.pickupPoints[i].location,
            lat: this.pickupPoints[i].lat,
            lng: this.pickupPoints[i].lng,
        };
        if (this.routeData && this.routeData.routeType && this.routeData.routeType != 'openBooking') {
            if (this.pickupPoints[i].employees) {
                this.editPickupForm['employees'] = [...this.pickupPoints[i].employees];
            }
            if (this.pickupPoints[i].guest) {
                this.editPickupForm['guest'] = [...this.pickupPoints[i].guest];
                this.pickupPointGuestList = [...this.pickupPoints[i].guest];
            }
        }

        if (this.pickupPoints[i].startLoc) this.editPickupForm['startLoc'] = this.pickupPoints[i].startLoc;
        if (this.pickupPoints[i].endLoc) this.editPickupForm['endLoc'] = this.pickupPoints[i].endLoc;
        this.editPPLabelIndex = i;
        if (this.selectedMap == 'google') {
            this.gglPickupPointMarkerLoc(+this.editPickupForm['lat'], +this.editPickupForm['lng'], this.editPickupForm['location']);
            this.googleMapObj.setZoom(13);
        } else {
            this.pickupPointMarker(+this.editPickupForm['lat'], +this.editPickupForm['lng']);
        }
        this.latlngDrawRadius(+this.editPickupForm['lat'], +this.editPickupForm['lng']);
    }
    // Cancel edit pickup point form
    editCancel() {
        let focusObj = {
            lat: this.editPickupForm['lat'],
            lng: this.editPickupForm['lng'],
            zoom: 12
        };

        this.editIndex = -1;
        this.editPPLabelIndex = -1;
        this.formSubmitted = false;
        this.editPickupForm = { ...this.formObject };
        this.errorFormObject = {};
        this.pickupFromMap = false;
        this.pickupPointGuestList = [];
        this.updateDuration = false;
        if (this.selectedMap != 'google') {
            this.primaryMap.focus(focusObj);
        }
        this.getPickupList();
        this.removeCircleAndMarker();
    }


    /***********************************************************************************/

    /*********************** Common pickup point form methods *************************/

    // Employee selection Call
    getEmployees() {
        this.closePopup = false;
        this.getSelectedEmps();
    }

    // Process selected pickup points employees
    getSelectedEmps() {
        this.getSelectedEmpList = {};
        if (this.pickupPoints.length > 0) {
            this.pickupPoints.map((pp) => {
                if (pp['employees']) {
                    pp['employees'].map((emps: any) => {
                        this.getSelectedEmpList[emps.employeeID] = true;
                    })
                }
            })
        }
        if (this.editPickupForm['employees']) this.editPickupForm['employees'].map((emps: any) => { this.getSelectedEmpList[emps.employeeID] = true; });
        if (this.pickupForm['employees']) this.pickupForm['employees'].map((emps: any) => { this.getSelectedEmpList[emps.employeeID] = true; });

    }

    // result from Employee selection Directive
    getSelectedEmployees(obj: any) {
        let employees = [];
        Object.values(obj).filter((emps) => { if (!this.getSelectedEmpList[emps['employeeID']]) employees.push(emps); });
        if (employees.length > 0) {
            if (this.createPickup) {
                if (this.pickupForm['employees'] == undefined) this.pickupForm['employees'] = [];

                this.pickupForm['employees'].push(...employees);
                if (this.formSubmitted) this.checkValidation('create');
            }
            else {
                this.editPickupForm['employees'].push(...employees);
                if (this.formSubmitted) this.checkValidation('edit');
            }
        }
        this.closePopup = true;
    }

    // Guest Selection List
    getSelectedGuestList(value) {
        if (Array.isArray(value)) {
            this.selectedGuestList = [];
            value.map((pp) => {
                if (pp.guest && Array.isArray(pp.guest) && pp.guest.length > 0) {
                    pp.guest.filter((guest) => {
                        let index = this.selectedGuestList.findIndex((g) => g.guestID == guest.guestID);
                        if (index == -1) this.selectedGuestList.push(guest);
                    })
                }
            })
        }
    }

    // Guest selection Popup open
    openGuestPopup() {
        this.guestModalTitle = "Guest Selection";
        this.guestEdit = false;
        this.editGuestObj = {};
        let availableSeats = this.checkGuestAvailablity();
        if (availableSeats) this.closeGuestPopup = false;
        else this.noSeatSnackBar();
    }

    // check seat availablity
    checkGuestAvailablity() {
        let avaiableSeats = false;
        if (this.selectedVeh && this.getAvailableGuestCount() > 0) avaiableSeats = true;
        return avaiableSeats
    }
    checkAvailablity() {
        let avaiableSeats = false;
        if (this.selectedVeh && this.getAvailableCount() < this.selectedVeh.capacity) avaiableSeats = true;
        return avaiableSeats
    }

    // Alert Message for Add Guest when seats are filled.
    noSeatSnackBar() {
        this._snackBar.open('No Available seats!', 'Close', { horizontalPosition: 'center', verticalPosition: 'top', duration: 3000 /* Milliseconds */, });
    }

    // Edit Guest
    editSelectedPickGuest(index) {
        this.editGuestObj = {};
        this.guestModalTitle = 'Edit Guest';
        this.guestEdit = true;
        this.editGuestIndex = index;
        if (this.editIndex == -1) {
            this.editGuestObj = { ...this.pickupForm['guest'][index] };
        }
        else if (this.editIndex != -1) {
            this.editGuestObj = { ...this.editPickupForm['guest'][index] };
        }
        this.closeGuestPopup = false;
    }

    // Get selected Guest Details
    getSelectedGuest(obj: any) {
        if (Object.keys(obj).length > 0) {
            if (obj.guestID) {

                let guestIndex = this.pickupPointGuestList.findIndex((guest) => { guest['guestID'] == obj['guestID'] });
                if (guestIndex == -1) this.pickupPointGuestList.push(obj);
                else this.pickupPointGuestList[guestIndex] = { ...obj };

                if (!this.guestEdit) {
                    if (this.pickupForm['guest'] == undefined) this.pickupForm['guest'] = [];

                    if (this.createPickup) this.pickupForm['guest'].push({ ...obj });
                    else this.editPickupForm['guest'].push({ ...obj });
                } else {
                    if (this.createPickup) this.pickupForm['guest'][this.editGuestIndex] = { ...obj };
                    else this.editPickupForm['guest'][this.editGuestIndex] = { ...obj };
                }
                if (this.formSubmitted) {
                    if (this.createPickup) this.checkValidation('create');
                    else this.checkValidation('edit');
                }
            }
            else {
                if (this.initialGuestAdd) this.addGuest(obj);
                this.initialGuestAdd = false;
            }
        }
        setTimeout(() => {
            this.guestEdit = false;
            this.guestModalTitle = "Guest Selection";
        }, 300);
    }

    // Add New Guest in DB
    addGuest(obj) {
        this.api.transportManagerGuestCreate(obj).then((res: any) => {
            if (res.status == 'success') {
                //   this.swal.swalFunction(res.status, res.status, res.message, 2000);
                this.getSelectedGuest({ guestID: res.data.guestID, ...obj });
                this.initialGuestAdd = true;
            }
            if (res.status == 'failure') {
                this.swal.swalFunction('error', res.status, res.message, 3000);
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    // Delete All Member from pickup point Form 
    deleteAllMember(index) {
        let parent = this;
        Swal.fire({
            title: 'Are you sure?',
            text: 'You want to delete all this members!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',//'#3085d6',
            //  cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {

                if (parent.editIndex != -1 && !parent.createPickup) {
                    this.editPickupForm['employees'] = [];
                    parent.pickupPoints[this.editIndex].employees = [];
                    this.editPickupForm['guest'] = [];
                    parent.pickupPoints[this.editIndex].guest = [];
                    parent.pickupPointGuestList = [];
                    if (this.formSubmitted) this.checkValidation('edit');
                }
                else if (parent.createPickup && parent.editIndex == -1) {
                    parent.pickupForm['employees'] = [];
                    parent.pickupForm['guest'] = [];
                    parent.pickupPointGuestList = [];
                    if (this.formSubmitted) this.checkValidation('create');
                }
                Swal.fire(
                    'Deleted!',
                    'All Members has been deleted.',
                    'success'
                );
            }
        });
    }

    // Delete selected Member from Pickup point form
    deleteSelectedPickMember(index, key, user) {
        let parent = this;
        Swal.fire({
            title: 'Are you sure?',
            text: 'You want to delete this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',//'#3085d6',
            //  cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {

                if (this.editIndex != -1 && !this.createPickup) {
                    this.removeGuestFromPP(parent.editPickupForm[key][index]);
                    this.editPickupForm[key].splice(index, 1);
                    if (parent.pickupPoints[this.editIndex][key]) {
                        parent.pickupPoints[this.editIndex][key].splice(index, 1);
                    }
                    if (this.formSubmitted) this.checkValidation('edit');
                }
                else if (this.createPickup && this.editIndex == -1) {
                    this.removeGuestFromPP(this.pickupForm[key][index]);
                    this.pickupForm[key].splice(index, 1);
                    if (this.formSubmitted) this.checkValidation('create');
                }

                Swal.fire(
                    'Deleted!',
                    `${user} has been deleted.`,
                    'success'
                );
            }
        });
    }

    // Remove guest from unique pickup point guest list
    removeGuestFromPP(obj) {
        let guestIndex = this.pickupPointGuestList.findIndex((guest) => guest['guestID'] == obj['guestID']);
        if (guestIndex != -1) this.pickupPointGuestList.splice(guestIndex, 1);
    }

    // check validation
    checkValidation(type) {
        if (this.formSubmitted) {
            if (type == 'create') this.pickupPointValidate(this.pickupForm);
            else if (type == 'edit') this.pickupPointValidate(this.editPickupForm);
        }
    }

    // pickup point form validation
    pickupPointValidate(object: any) {
        let isValid = true;
        for (let key in object) {
            if (key != 'employees' && key != 'guest' && object[key] == '' || object[key] == null || object[key] == undefined) {
                this.errorFormObject[key] = key[0].toUpperCase() + key.slice(1).toLowerCase() + ' is required.';
                isValid = false;
            }
            else if (key == 'radius' && object[key] != '' && object[key] != null && object[key] != undefined) {
                if (object[key] > 10 || object[key] < 0) {
                    this.errorFormObject[key] = "Radius must be In between 0 and 10";
                    isValid = false;
                }
                else {
                    this.errorFormObject[key] = '';
                }
            }
            else if (key == 'eta' && object[key] != '' && object[key] != null && object[key] != undefined) {
                let customETA = parseFloat(object[key].replace(":", "."));
                if (this.routeData['startTime'] > this.routeData['endTime']) {
                    if (customETA <= 23.59 && ((customETA > this.routeData['startTime']) || (customETA < this.routeData['endTime']))) {   //(customETA > this.routeData['startTime']) && (customETA < this.routeData['endTime'])
                        this.errorFormObject[key] = '';
                    } else {
                        this.errorFormObject[key] = "ETA should in between route time.";
                        isValid = false;
                    }
                }
                else {
                    if (customETA <= 23.59 && ((customETA > this.routeData['startTime']) && (customETA < this.routeData['endTime']))) {   //(customETA > this.routeData['startTime']) && (customETA < this.routeData['endTime'])
                        this.errorFormObject[key] = '';
                    } else {
                        this.errorFormObject[key] = "ETA should in between route time.";
                        isValid = false;
                    }
                }
            }
         else if ((key == 'employees' || key == 'guest') && this.generalSetting == false) {
                    if (object['employees'].length <= 0 && object['guest'].length <= 0) {
                        this.errorFormObject['members'] = 'Members is required.'
                        isValid = false;
                    }
                    else this.errorFormObject['members'] = '';
                }

            else this.errorFormObject[key] = '';
        }
        return isValid;
    }

    // add pickup Points
    savePickup() {
        this.formSubmitted = true;
        let isValid = this.pickupPointValidate(this.pickupForm);
        console.log(isValid, this.pickupPointValidate(this.pickupForm), this.pickupForm);
        if (isValid) {
            this.savePickupPoints();
        }
    }

    // Add pickup points in DB
    savePickupPoints() {
        let obj = {
            vehRegNo: this.selectedVeh.vehRegNo,
            routeID: this._routeID,
            pickupInfo: [{
                ...this.pickupForm
            }],
        };

        let apiMethod = 'addRoutePickupPoint';
        if (this.routeData && this.routeData.routeType && this.routeData.routeType == 'openBooking') {
            apiMethod = 'transportManagerOpenBookingRouteCreatePP';
            delete obj.pickupInfo;
            obj = { ...obj, ...this.pickupForm };
        }
        this.api[apiMethod](obj).then((res: any) => {
            if (res.status == 'success') {
                this.swal.swalFunction(res.status, res.status, res.message, 2000);
                setTimeout(() => {
                    if (this.createPickup) this.createPickup = false;
                    this.pickupFromMap = false;
                    this.removeCircleAndMarker();
                    this.updateDuration = true;
                    this.getPickupList();
                    this.formSubmitted = false;
                    this.loadMap();
                }, 3000)
            } else {
                this.swal.swalFunction('error', res.status, res.message, 2000);
            }
        })
    }

    // Update pickup points validation
    updatePickup() {
        this.formSubmitted = true;
        let isValid = this.pickupPointValidate(this.editPickupForm);
        if (isValid) {
            let obj = {
                vehRegNo: this.selectedVeh.vehRegNo,
                routeID: this._routeID,
                pickuppointID: this.pickupPoints[this.editIndex].pickuppointID,
                pickupInfo: [{ ...this.editPickupForm }],
            };
            this.updatePickupPoints(obj);
            setTimeout(() => {
                this.editIndex = -1;
                this.pickupFromMap = false;
                this.removeCircleAndMarker();
                this.loadMap();
            }, 3000);
        }
    }

    // update pickup points in DB
    updatePickupPoints(obj) {
        let apiMethod = 'updateRoutePickupPoint';
        if (this.routeData && this.routeData.routeType && this.routeData.routeType == 'openBooking')
            apiMethod = 'transportManagerOpenBookingRouteUpdatePP';

        this.api[apiMethod](obj).then((res: any) => {
            if (res.status == 'success') {
                this.swal.swalFunction(res.status.toLowerCase(), res.status, res.message, 2000);
                setTimeout(() => {
                    this.updateDuration = true;
                    this.getPickupList();
                    this.formSubmitted = false;
                }, 3000)
            } else {
                this.swal.swalFunction('error', res.status, res.message, 2000);
            }
        })
    }

    // Delete pickup point
    delete(i) {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You want to delete this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',//'#3085d6',
            //  cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                this.deletePickup(i);
                this.loadMap();
            }
        });

    }

    // delete pickup point from DB
    deletePickup(pickup) {
        let obj = {
            vehRegNo: this.selectedVeh.vehRegNo,
            routeID: this._routeID,
            pickuppointID: pickup.pickuppointID,
            pickupInfo: [{ ...pickup }],
        }

        let apiMethod = 'deleteRoutePickupPoint';
        if (this.routeData && this.routeData.routeType && this.routeData.routeType == 'openBooking')
            apiMethod = 'transportManagerOpenBookingRouteDeletePP';

        this.api[apiMethod](obj).then((res: any) => {
            if (res.status == 'success') {
                this.swal.swalFunction(res.status, res.status, res.message, 2000);
                setTimeout(() => {
                    this.editIndex = -1;
                    this.pickupFromMap = false;
                    this.updateDuration = true;
                    this.pickupForm = { ...this.formObject };
                    this.editPickupForm = { ...this.formObject };
                    this.removeCircleAndMarker();
                    this.getPickupList();
                }, 3000)
            } else {
                this.swal.swalFunction('error', res.status, res.message, 2000);
            }
        })
    }

    /**********************************************************************************/


    /******************************* Change Employee Type *****************************/
    getChangableEmp(formType, emp, index) {
        this.selectedEmployee = { ...emp };
        this.tempEmpIndex = index;
        this.selectedFormType = formType;
        this.closeEmpTypePopup = false;
    }

    changedEmpDuration(event) {
        let form = 'pickupForm';
        if (this.selectedFormType == 'edit') form = 'editPickupForm';
        let employee = { ...this[form]['employees'][this.tempEmpIndex] };
        delete employee.fromDate;
        delete employee.toDate;
        employee['isTemp'] = event.isTemp;
        if (event.isTemp) {
            employee['fromDate'] = event.fromDate;
            employee['toDate'] = event.toDate;
        }
        this[form]['employees'][this.tempEmpIndex] = employee;
        /* 
        1. restore pickuppoint list from api
        2. reload Edit pickuppoint data
        3. reload Employee Table
        */
    }

    /**********************************************************************************/

    /******************************* Check pickup point Title null *******************/

    checkPPtitle(pickuppoint) {
        if (pickuppoint) {
            if (pickuppoint.title && pickuppoint.location) {
                if (pickuppoint.title == 'Pickup point' && pickuppoint.location == 'Pickup point') return true;
                else if (pickuppoint.title == 'Drop point' && pickuppoint.location == 'Drop point') return true;
            } else return false;
        } else return false;
    }
    checkAllPPtitle(pickuppoints) {
        if (Array.isArray(pickuppoints) && pickuppoints.length > 0) {
            for (let p = 0; p < pickuppoints.length; p++) {
                if (this.checkPPtitle(pickuppoints[p])) return true;
            }
        }
        return false;
    }


    /**********************************************************************************/

}